import { render, staticRenderFns } from "./Orderbook.vue?vue&type=template&id=d7a8dd7e&scoped=true&"
import script from "./Orderbook.vue?vue&type=script&lang=ts&"
export * from "./Orderbook.vue?vue&type=script&lang=ts&"
import style0 from "./Orderbook.vue?vue&type=style&index=0&id=d7a8dd7e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7a8dd7e",
  null
  
)

export default component.exports